module.exports = __webpack_public_path__ + "img/3B_old.96237129.jpg";